<template>
    <el-dialog title="Доп соглашение" :visible.sync="visibleModalModel" width="550px" :append-to-body="true" v-loading="isLoading">
        <AdditionalAgreementForm v-if="agreement" mode="edit" @saved="onSaved" :agreement="agreement"  />
    </el-dialog>
</template>

<script>

import AdditionalAgreementForm from "./AdditionalAgreementForm";
export default {
    name: "ModalEdit",
    components: {AdditionalAgreementForm},
    props: ['visibleModal', 'agreementId'],
    data: () => ({
        isLoading: false,
        agreement: null,
    }),
    mounted() {
        this.fetch();
    },
    computed: {
        visibleModalModel: {
            get () { return this.visibleModal },
            set (value) { this.$emit('update:visibleModal', value) },
        },
    },
    methods: {
        onSaved(agreement) {
            this.visibleModalModel = false;
            this.$emit('saved', agreement);
        },
        fetch() {
            this.isLoading = true;
            axios.get('/api/additional_agreements/' + this.agreementId)
                .then(res => {
                    this.agreement = res.data;
                    this.isLoading = false;
                })
        }
    }
}
</script>

<style scoped>

</style>
